/**
 * DEFAULT_COLORS — the fallback chart colour palette used when no explicit
 * theme or per-series override is configured.
 *
 * Sourced from Tableau 10 with minor accessibility adjustments.
 * This is the single source of truth — other packages should import from here
 * (or re-export) rather than maintaining their own copy.
 */
export const DEFAULT_COLORS: string[] = [
  '#4E79A7',
  '#F28E2B',
  '#E15759',
  '#76B7B2',
  '#59A14F',
  '#EDC948',
  '#B07AA1',
  '#FF9DA7',
];

/**
 * Stable ID for the built-in Trinity theme. Uses a negative integer so it
 * never collides with user-created theme IDs (which use Date.now()).
 */
export const TRINITY_THEME_ID = -1;

/**
 * TRINITY_THEME — the built-in branded colour palette for Trinity dashboards.
 * Applied by default to all new chart widgets in the Page Builder.
 *
 * Colours are derived from the Trinity/MSL Copilot brand guidelines:
 *   Primary blue → complementary data palette with good contrast on white.
 */
export const TRINITY_THEME = {
  id: TRINITY_THEME_ID,
  name: 'Trinity',
  colors: [
    '#28AAE1', // Primary sky blue
    '#1B5FAE', // Deep navy
    '#43C59E', // Teal green
    '#F5A623', // Amber
    '#E84C3D', // Coral red
    '#9B59B6', // Purple
    '#2ECC71', // Emerald
    '#F39C12', // Dark amber
  ],
} as const;
